import { useEffect, useState } from 'react'

const noop = () => null

/*
 * Fetch a list once (when `isOpen` turns true, or at mount if `eager`) and
 * cache it for the component's lifetime — it is never re-fetched. `fetcher`
 * and `extractor` must be stable references, else the effect re-triggers.
 */
const useLazyList = ({ collectId, isOpen, fetcher, extractor, eager = false, enabled = true }) => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!enabled)
      return noop
    if (items.length > 0)
      return noop
    if (!isOpen && !eager)
      return noop
    let cancelled = false
    setLoading(true)
    setError(null)
    fetcher(collectId).then(response => {
      if (cancelled)
        return
      setItems(extractor(response))
    }).catch(caught => {
      if (cancelled)
        return
      setError(caught)
    }).finally(() => {
      if (!cancelled)
        setLoading(false)
    })
    return () => {
      cancelled = true
    }
  }, [collectId, isOpen, eager, enabled, items.length, fetcher, extractor])

  return { items, loading, error }
}

export default useLazyList
